import styled from 'styled-components';
import ArrowDropDownSvg from './../assets/arrow-drop-down.svg';

const ArrowDropDownIcon = styled(ArrowDropDownSvg as React.SFC<React.SVGProps<SVGSVGElement>>)(
  props => `
  margin-right: ${props.theme.spacing.base};
  cursor: pointer;
`,
);

export default ArrowDropDownIcon;
